(function () {
  document.documentElement.classList.remove('no-js');

  var ageGate = document.querySelector('[data-age-gate]');
  var discountPopup = document.querySelector('[data-discount-popup]');
  var idleScreensaver = document.querySelector('[data-idle-screensaver]');
  var idleTimer;

  function isBlockingOverlayOpen() {
    return (
      (ageGate && !ageGate.hidden) ||
      (discountPopup && !discountPopup.hidden) ||
      document.body.classList.contains('menu-open')
    );
  }

  function hideIdleScreensaver() {
    if (!idleScreensaver) return;
    idleScreensaver.hidden = true;
    document.body.classList.remove('idle-screensaver-open');
  }

  function showIdleScreensaver() {
    if (!idleScreensaver || isBlockingOverlayOpen()) {
      scheduleIdleScreensaver();
      return;
    }

    idleScreensaver.hidden = false;
    document.body.classList.add('idle-screensaver-open');
  }

  function scheduleIdleScreensaver() {
    if (!idleScreensaver) return;
    window.clearTimeout(idleTimer);
    var timeout = Number(idleScreensaver.dataset.idleTimeout || 120000);
    idleTimer = window.setTimeout(showIdleScreensaver, timeout);
  }

  function resetIdleScreensaver() {
    hideIdleScreensaver();
    scheduleIdleScreensaver();
  }

  function initMobileProductRails() {
    if (!window.matchMedia('(pointer: coarse)').matches && !window.matchMedia('(max-width: 900px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var rails = Array.prototype.slice.call(document.querySelectorAll('.home-category-row__rail[data-auto-rail="true"]'));
    if (!rails.length) return;

    rails.forEach(function (rail) {
      var direction = rail.dataset.direction === 'right' ? -1 : 1;
      var paused = false;
      var resumeTimer;
      var initialized = false;
      var speed = 1;

      function loopPoint() {
        return Math.max(0, Math.floor((rail.scrollWidth - rail.clientWidth) / 2));
      }

      function setStartPoint() {
        var resetAt = loopPoint();
        if (resetAt <= 4) return;
        if (direction < 0) rail.scrollLeft = resetAt;
        initialized = true;
      }

      setStartPoint();
      window.setTimeout(setStartPoint, 700);
      window.addEventListener('load', setStartPoint, { once: true });

      function pause() {
        paused = true;
        window.clearTimeout(resumeTimer);
      }

      function resumeSoon() {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(function () {
          paused = false;
        }, 850);
      }

      rail.addEventListener('touchstart', pause, { passive: true });
      rail.addEventListener('touchend', resumeSoon, { passive: true });
      rail.addEventListener('touchcancel', resumeSoon, { passive: true });
      rail.addEventListener('pointerdown', pause, { passive: true });
      rail.addEventListener('pointerup', resumeSoon, { passive: true });
      rail.addEventListener('pointercancel', resumeSoon, { passive: true });

      window.setInterval(function () {
        var resetAt = loopPoint();
        if (paused || resetAt <= 4) return;
        if (!initialized) setStartPoint();

        rail.scrollLeft += direction * speed;

        if (direction > 0 && rail.scrollLeft >= resetAt) {
          rail.scrollLeft = 0;
        }

        if (direction < 0 && rail.scrollLeft <= 0) {
          rail.scrollLeft = resetAt;
        }
      }, 30);
    });
  }

  if (ageGate && localStorage.getItem('chillaAgeVerified') !== 'true') {
    ageGate.hidden = false;
  }

  function showDiscountPopup() {
    if (!discountPopup) return;
    if (localStorage.getItem('chillaDiscountCaptured') === 'true') return;
    if (localStorage.getItem('chillaDiscountDismissed') === 'true') return;
    if (ageGate && !ageGate.hidden) return;

    var delay = Number(discountPopup.dataset.delay || 4000);
    window.setTimeout(function () {
      if (ageGate && !ageGate.hidden) return;
      discountPopup.hidden = false;
      document.body.classList.add('discount-popup-open');
      var email = discountPopup.querySelector('input[type="email"]');
      if (email) email.focus({ preventScroll: true });
    }, delay);
  }

  function closeDiscountPopup(persist) {
    if (!discountPopup) return;
    discountPopup.hidden = true;
    document.body.classList.remove('discount-popup-open');
    if (persist) localStorage.setItem('chillaDiscountDismissed', 'true');
  }

  function revealDiscountCode() {
    if (!discountPopup) return;
    var formWrap = discountPopup.querySelector('[data-discount-form-wrap]');
    var success = discountPopup.querySelector('[data-discount-success]');
    if (formWrap) formWrap.hidden = true;
    if (success) success.hidden = false;
    localStorage.setItem('chillaDiscountCaptured', 'true');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-menu-open]');
    if (opener) {
      var isOpen = document.body.classList.toggle('menu-open');
      opener.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (!isOpen) {
        document.querySelectorAll('.nav-dropdown.is-open').forEach(function (dropdown) {
          dropdown.classList.remove('is-open');
          var toggle = dropdown.querySelector('[data-shop-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      }
    }

    var shopToggle = event.target.closest('[data-shop-toggle]');
    if (shopToggle) {
      event.preventDefault();
      var dropdown = shopToggle.closest('.nav-dropdown');
      if (dropdown) {
        var shopOpen = dropdown.classList.toggle('is-open');
        shopToggle.setAttribute('aria-expanded', shopOpen ? 'true' : 'false');
      }
    }

    var productBack = event.target.closest('[data-product-back]');
    if (productBack) {
      var referrer = document.referrer;
      if (referrer && new URL(referrer).origin === window.location.origin && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    }

    var enter = event.target.closest('[data-age-enter]');
    if (enter) {
      localStorage.setItem('chillaAgeVerified', 'true');
      if (ageGate) ageGate.hidden = true;
      showDiscountPopup();
    }

    var close = event.target.closest('[data-menu-close]');
    if (close) {
      document.body.classList.remove('menu-open');
    }

    var navLink = event.target.closest('.nav a');
    if (navLink && document.body.classList.contains('menu-open')) {
      document.body.classList.remove('menu-open');
      var menuButton = document.querySelector('[data-menu-open]');
      if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
    }

    var discountClose = event.target.closest('[data-discount-close]');
    if (discountClose) {
      closeDiscountPopup(true);
    }

    var discountCopy = event.target.closest('[data-discount-copy]');
    if (discountCopy && discountPopup) {
      var code = discountPopup.dataset.discountCode || '';
      navigator.clipboard.writeText(code).then(function () {
        var helper = discountCopy.querySelector('small');
        if (helper) helper.textContent = 'Copied';
      }).catch(function () {
        window.prompt('Copy your discount code', code);
      });
    }
  });

  ['pointerdown', 'keydown', 'mousemove', 'touchstart', 'scroll'].forEach(function (eventName) {
    window.addEventListener(eventName, resetIdleScreensaver, { passive: true });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.discount-popup form');
    if (!form) return;

    event.preventDefault();
    var email = form.querySelector('input[type="email"]');
    if (email && !email.checkValidity()) {
      email.reportValidity();
      return;
    }

    var submit = form.querySelector('button[type="submit"]');
    if (submit) submit.disabled = true;

    fetch(form.action || window.location.href, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'text/html' }
    }).catch(function () {
      return null;
    }).finally(function () {
      revealDiscountCode();
      if (submit) submit.disabled = false;
    });
  });

  showDiscountPopup();
  scheduleIdleScreensaver();
  initMobileProductRails();
})();
